import { BatchJob, BatchJobStatus } from "reducers/types";

// Pure helpers of useJobPolling (no React), so the rules stay readable and testable later.
// Which job a card shows is decided by the server (GET {base}/current).

export interface PollingIntervals {
  activeIntervalMs: number;
  waitingIntervalMs: number;
  queuedIntervalMs: number;
  hiddenIntervalMs: number;
  maxBackoffMs: number;
}

const ACTIVE: BatchJobStatus[] = ["PENDING", "RUNNING", "AWAITING_APPROVAL", "WAITING_FOR_PROVIDER"];

export const isActive = (status: BatchJobStatus): boolean => ACTIVE.indexOf(status) >= 0;

/**
 * Delay until the next poll, or null to stay idle (nothing active, no error).
 */
export const nextDelay = (
  shown: BatchJob | null,
  queuedCount: number,
  errorCount: number,
  hidden: boolean,
  intervals: PollingIntervals,
): number | null => {
  if (errorCount > 0) {
    return Math.min(intervals.maxBackoffMs, 2000 * Math.pow(2, errorCount - 1));
  }
  if (shown && isActive(shown.status)) {
    if (hidden) {
      return intervals.hiddenIntervalMs;
    }
    return shown.status === "WAITING_FOR_PROVIDER" ? intervals.waitingIntervalMs : intervals.activeIntervalMs;
  }
  if (queuedCount > 0) {
    return hidden ? intervals.hiddenIntervalMs : intervals.queuedIntervalMs;
  }
  return null;
};

/** True if the light view shows a different job or a newer version than the one on screen. */
export const changed = (shown: BatchJob | null, next: BatchJob | null): boolean => {
  if (!shown || !next) {
    return shown !== next;
  }
  return shown.jobId !== next.jobId || shown.version !== next.version;
};
